import type { Dispatch } from "redux";

import { sidebarConstants } from "./types";

export const sidebarShow = () => {
  return (dispatch: Dispatch) => {
    dispatch({ type: sidebarConstants.SIDEBAR_SHOW });
  };
};

export const sidebarHide = () => {
  return (dispatch: Dispatch) => {
    dispatch({ type: sidebarConstants.SIDEBAR_HIDE });
  };
};
